import React from "react"

import { size } from "lodash-es"

export interface IAvatarData {
  id?: string
  name?: string
  avatar: string
}

interface AvatarGroupProps {
  data: IAvatarData[]
  maxVisible?: number
  avatarSize?: number
  borderColor?: string
  totalNumberOfPossibleAvatars?: number
}

const AvatarGroup: React.FC<AvatarGroupProps> = ({
  data,
  maxVisible = 5,
  avatarSize = 50,
  borderColor = "#fff",
  totalNumberOfPossibleAvatars = 0,
}) => {
  const visibleAvatars = data.slice(0, maxVisible)
  const countOfAllUnseenAvatars =
    Math.max(size(data), totalNumberOfPossibleAvatars) - maxVisible

  return (
    <div className="flex items-center -space-x-4">
      {visibleAvatars.map((item, index) => {
        return (
          <img
            key={index}
            src={item.avatar}
            alt={"?"}
            className="border-2 object-cover rounded-full"
            style={{
              width: avatarSize,
              height: avatarSize,
              borderColor,
            }}
          />
        )
      })}
      {countOfAllUnseenAvatars > 0 && (
        <div
          className="flex items-center justify-center border-2 text-white font-bold backdrop-blur-md bg-white/30 rounded-full"
          style={{
            width: avatarSize,
            height: avatarSize,
            borderColor,
          }}
        >
          +{countOfAllUnseenAvatars}
        </div>
      )}
    </div>
  )
}

export default AvatarGroup
